import api from "..";

import { convertBRToUSDate, getFidelityByDDD, getOnlyNumbers } from "@/utils";
import {
  DebtSaleRequestExtraData,
  SaleRawData,
  SaleRequestData,
  UserPrefs,
} from "./types";

const formatSaleRequest = (data: SaleRawData): SaleRequestData => {
  const debtPayment = {
    agencia: data.payment.agency,
    banco: data.payment.bank,
    conta: data.payment.account,
  };

  const bankData: Partial<DebtSaleRequestExtraData> =
    data.paymentType?.value === "Débito Automatico" ? debtPayment : {};

  const fidelidadeTIMId = {
    fidelidade: getFidelityByDDD(
      data.product.fidelidades,
      String(getOnlyNumbers(data.tel).slice(0, 2))
    )?.tim_id,
  };

  const loyaltyData = data.loyalty ? fidelidadeTIMId : {};

  const configurationPackage = data.product.pacote_configuracoes_id_substituto
    ? {
        pacote_configuracoes_id_substituto:
          data.product.pacote_configuracoes_id_substituto,
      }
    : {};

  return {
    uuid: data.uuid,
    bairro: data.address.neighborhood,
    cep: getOnlyNumbers(data.address.zipCode),
    cidade: data.address.cityName,
    complemento: data.address.complement || null,
    ponto_referencia: data.address.referencePoint || null,
    cpf: getOnlyNumbers(data.cpf),
    email: data.email,
    filiacao: data.motherName,
    forma_pagamento: data.paymentType!.value,
    logradouro: data.address.street,
    msisdn: getOnlyNumbers(data.tel),
    autorizar_receber_contato: data.autorizarContato,
    nascimento: convertBRToUSDate(data.birthDate),
    nome: data.fullName,
    numero: data.address.noNumber ? "0" : data.address.number,
    plano: data.product.tim_id,
    telefone: data.tel,
    tipo_fatura: "Conta Online",
    tipo: data.tipo,
    possui_provisorio: data.possuiProvisorio,
    uf: data.address.stateCode,
    vencimento: data.payment.debtDueDate,
    utm_campaign: data.utm_campaign,
    utm_medium: data.utm_medium,
    utm_source: data.utm_source,
    userPrefs: (data.userPrefs as UserPrefs) || null,
    ...loyaltyData,
    ...bankData,
    ...configurationPackage,
  };
};

export const requestCreateSale = async (saleData: SaleRawData) => {
  const { data } = await api.post("/core/vendas", {
    sale_form: formatSaleRequest(saleData),
  });
  if (typeof gtag === "function") {
    gtag("event", "conversion", {
      send_to: import.meta.env.VITE_GOOGLE_CONVERSION_EVENT,
    });
  }
  return data;
};
